import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import Spinner from 'creative-ui/uikit/Spinner';

import Flex from '../Layout/Flex/Flex';

export function LoadingCard() {
  return (
    <BaseWrapper>
      <Flex justify="center">
        <Spinner />
      </Flex>
    </BaseWrapper>
  );
}
